module.exports = __webpack_public_path__ + "img/home-banner.8d839e6f.jpg";